import z from 'zod';

export const templateSchema = z
	.object({
		id: z.string(),
		source: z.enum(['db', 'file']),
		type: z.enum(['email', 'sms']),
		template: z.string(),
		preview: z.string(),
	})
	.describe('Template');

export const templateApiResponseSchema = z.object({ data: z.array(z.object({ id: z.string() })) });

// Email-template editor (admin Notifications) — API contracts for the prompt-based editor.
export const emailTemplateListItemSchema = z
	.object({
		id: z.string(),
		description: z.string().optional(),
		recipients: z.string().optional(),
		trigger: z.string().optional(),
		customized: z.boolean().optional(),
	})
	.describe('EmailTemplateListItem');

export const emailTemplateListResponseSchema = z
	.object({ data: z.array(emailTemplateListItemSchema) })
	.describe('EmailTemplateListResponse');

export const emailTemplateDetailSchema = z
	.object({
		id: z.string(),
		source: z.enum(['db', 'file']),
		template: z.string(),
		preview: z.string(),
	})
	.describe('EmailTemplateDetail');

export const emailTemplatePreviewSchema = z
	.object({
		template: z.string(),
		preview: z.string(),
		allowedVars: z.array(z.string()),
		siteScoped: z.boolean(),
		customized: z.boolean(),
	})
	.describe('EmailTemplatePreview');

// One prior chat turn, sent so the model has conversation context (answer follow-ups, build on edits).
export const aiEditTurnSchema = z
	.object({ role: z.enum(['user', 'assistant']), content: z.string() })
	.describe('AiEditTurn');

export const aiEditResultSchema = z
	.object({
		id: z.string(),
		template: z.string().optional(),
		preview: z.string().optional(),
		allowedVars: z.array(z.string()),
		mjmlErrors: z.array(z.string()).optional(),
		unknownVars: z.array(z.string()).optional(),
		// Set when the model asked a clarifying question instead of editing.
		question: z.string().optional(),
		// Set when the model answered/explained instead of editing (no template change applied).
		reply: z.string().optional(),
	})
	.describe('AiEditResult');

// One saved version, reconstructed from the audit log. Doubles as a restorable checkpoint.
export const templateCheckpointSchema = z
	.object({
		instructions: z.array(z.string()),
		template: z.string(),
		actor: z.string(),
		at: z.string(),
	})
	.describe('TemplateCheckpoint');

export const templateHistoryResponseSchema = z
	.object({ history: z.array(templateCheckpointSchema) })
	.describe('TemplateHistoryResponse');

export const templateLanguageSchema = z
	.object({
		code: z.string(),
		name: z.string(),
		exists: z.boolean(),
		stale: z.boolean(),
		// manually refined since generation — re-translating would overwrite it
		edited: z.boolean(),
	})
	.describe('TemplateLanguage');

export const templateI18nSchema = z
	.object({
		defaultLanguage: z.string(),
		defaultLanguageName: z.string(),
		languages: z.array(templateLanguageSchema),
	})
	.describe('TemplateI18n');

export const templateTranslateResponseSchema = z
	.object({ languages: z.array(z.string()), previews: z.record(z.string(), z.string()) })
	.describe('TemplateTranslateResponse');
